import { AppButtonIcon } from "@components"
import React from "react"
import { batch } from "@preact/signals-react"

export default function AnalyzerEvolutionChartActions({ setIsVisible, setIsLoading }) {

	const handleButtonClick = () => batch(() => {
		setIsLoading(true)
		setTimeout(() => {
			setIsLoading(false)
		}, 100)
		setIsVisible()
	})


	return <AppButtonIcon
		iconProps={{ iconWeight: "solid" }}
		tooltip="Show/Hide Legend"
		onClick={handleButtonClick}
		icon="eye-slash"
	/>
}
